import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Sprite from '@components/Sprite'
import classNames from 'classnames'
import { graphql, StaticQuery } from 'gatsby'
import RichText from '@components/RichText'
import * as styles from '~/styles/components/register.module.scss'
import * as editorStyles from '~/styles/components/editor.module.scss'
import Parse from 'html-react-parser'

const DOTDIGITAL_EMBED_ID = '74M7-1C0'

export default class Register extends Component {
  constructor () {
    super()
    this.form = React.createRef()
  }

  componentDidMount () {
    this.loadForm()
  }

  componentWillUnmount () {
    // Register is mounted/unmounted each time the modal opens. DotDigital's
    // embed.js tracks processed page IDs in a global window array and
    // silently refuses to re-open a form for an ID it's already seen, so
    // without this the form only ever loads on the first time the modal is
    // opened. Clearing our ID here lets the next mount register cleanly.
    if (window.__dmProcessedPages) {
      const index = window.__dmProcessedPages.indexOf(DOTDIGITAL_EMBED_ID)
      if (index > -1) window.__dmProcessedPages.splice(index, 1)
    }
  }

  loadForm () {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = `https://r1.dotdigital-pages.com/resources/sharing/embed.js?sharing=lp-embed&domain=r1.dotdigital-pages.com&id=${DOTDIGITAL_EMBED_ID}`
      this.form.current.appendChild(script)
      script.addEventListener('load', function () {
        const iframeElement = document.getElementById(DOTDIGITAL_EMBED_ID)
        iframeElement?.setAttribute('title', 'Sign up for our newsletter')
        resolve()
      })
    })
  }

  render () {
    return (
      <StaticQuery
        query={query} render={({ register }) => (
          <div className={classNames(styles.overlay)}>
            <section className={styles.modal}>
              <button className={styles.close} type="button" aria-label="Close" onClick={this.props.onClick}>
                <span className={styles.cross}>
                  <Sprite name="crossThin" fill={true} />
                </span>
              </button>

              <span className={classNames(styles.icon, 'icon')}>
                {/* <Sprite name="envelope" /> */}
                {Parse('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 24"><defs><linearGradient x1="28.675%" y1="27.778%" x2="62.634%" y2="72.222%" id="sprite-envelope-newsletter"><stop stop-color="#FFFFFF" offset="0%"/><stop stop-color="#1DA1F2" offset="100%"/></linearGradient></defs><path d="M1.6 0C.734 0 0 .734 0 1.6v20.8c0 .866.734 1.6 1.6 1.6h32.8c.866 0 1.6-.734 1.6-1.6V1.6c0-.866-.734-1.6-1.6-1.6H1.6zm2.375 2.4h28.05L18 14.425 3.975 2.4zM2.4 4.188L17.225 16.9a1.2 1.2 0 001.55 0L33.6 4.188V21.6H2.4V4.188z" fill="#FFFFFF" fill-rule="nonzero"/></svg>')}
              </span>

              <div className={classNames(styles.content, 'grid-x grid-small-center')}>
                <div className="cell smedium-8 medium-6">
                  <h3 className={styles.title}>
                    {register.title}
                  </h3>

                  {register.text && (
                    <div className={classNames(styles.text, editorStyles.editor)}>
                      <RichText json={JSON.parse(register.text.raw)} />
                    </div>
                  )}

                  <div className={styles.form} ref={this.form}></div>
                </div>
              </div>
            </section>
          </div>
        )}
      />
    )
  }
}

export const query = graphql`
  query {
    register: contentfulRegister(title: {regex: "/^(?!.*(sample))/gi"}) {
      title
      text {
        raw
      }
    }
  }
`

Register.propTypes = {
  onClick: PropTypes.func
}
